import { useSite } from "@/context/SiteContext";
import { FALLBACK_CONFIG, CARRIER_DISCLOSURE } from "@/data/siteContent";
import Reveal from "@/components/Reveal";

const DEFAULT_CARRIERS = [
  { name: "Transamerica Life Insurance Co", logo: "/assets/carriers/transamerica.png", enabled: true, note: "Final expense and term life options" },
  { name: "Mutual of Omaha", logo: "/assets/carriers/mutual-of-omaha.svg", enabled: true, note: "Whole life and final expense products" },
  { name: "Guarantee Trust Life Insurance Co", logo: "/assets/carriers/guarantee-trust-life.png", enabled: true, note: "Final expense and senior-focused coverage" },
  { name: "American Amicable Life Insurance Co", logo: "/assets/carriers/american-amicable.png", enabled: true, note: "Simplified-issue life insurance" },
  { name: "CoreBridge Financial", logo: "/assets/carriers/corebridge.png", enabled: true, note: "Term and permanent life insurance" },
  { name: "Aflac", logo: "/assets/carriers/aflac.png", enabled: true, note: "Supplemental and life coverage" },
  { name: "Gerber Life Insurance", logo: "/assets/carriers/gerber-life.png", enabled: true, note: "Whole life and guaranteed-issue options" },
];

export function useCarriers() {
  const site = useSite();
  const list = site.carriers && site.carriers.length ? site.carriers : (FALLBACK_CONFIG.carriers.length ? FALLBACK_CONFIG.carriers : DEFAULT_CARRIERS);
  return list.filter((c) => c.enabled !== false);
}

export function CarrierMarquee() {
  const carriers = useCarriers();
  const doubled = [...carriers, ...carriers];
  return (
    <div className="relative overflow-hidden border-y border-navy-100 bg-white py-6" aria-label="Insurance carriers" data-testid="carrier-marquee">
      <div className="flex w-max animate-marquee items-center gap-16 pr-16 motion-reduce:animate-none">
        {doubled.map((c, i) => (
          <span key={i} className="font-serif text-xl text-navy/60 whitespace-nowrap" aria-hidden={i >= carriers.length}>
            {c.name}
          </span>
        ))}
      </div>
    </div>
  );
}

export default function CarrierGrid({ showNotes = false }) {
  const carriers = useCarriers();
  return (
    <div>
      <div className="grid grid-cols-2 gap-5 sm:grid-cols-3 lg:grid-cols-4" data-testid="carrier-grid">
        {carriers.map((c, i) => (
          <Reveal key={c.name} delay={i * 0.06}>
            <div className="flex h-full flex-col items-center justify-center gap-3 rounded-xl border border-navy-100/70 bg-white p-6 text-center shadow-sm transition-shadow duration-300 hover:shadow-md"
              data-testid={`carrier-tile-${i}`}>
              <img src={c.logo} alt={`${c.name} logo`} className="h-12 w-auto max-w-full object-contain" loading="lazy" />
              <p className="text-sm font-semibold text-navy leading-snug">{c.name}</p>
              {showNotes && c.note && <p className="text-sm text-mutedink">{c.note}</p>}
            </div>
          </Reveal>
        ))}
      </div>
      <p className="mt-8 text-sm text-mutedink leading-relaxed max-w-3xl" data-testid="carrier-disclosure">
        {CARRIER_DISCLOSURE} Carriers shown are those 1907 Insurance Group works with; active appointments are
        confirmed before any recommendation is made.
      </p>
    </div>
  );
}
